import { hotComments } from '@/mocks/data';

export default function CommentSection() {
  return (
    <section className="bg-background-200 py-10 md:py-14">
      <div className="container-page">
        <div className="flex flex-col items-center text-center mb-10">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
            <span className="text-primary-500 text-xs tracking-wider">吃瓜热评</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            万人围观实评 / 吃瓜前线热评
          </h2>
          <p className="text-secondary-500 text-sm mt-2 font-light">
            来自千万吃瓜群众的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotComments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-300 rounded-lg p-5 transition-transform hover:-translate-y-1 duration-300"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < comment.rating ? 'text-primary-500 ri-fire-fill' : 'text-secondary-600 ri-fire-line'}`}></i>
                  </span>
                ))}
              </div>
              <h4 className="text-foreground-800 text-sm font-semibold mb-2">
                {comment.headline}
              </h4>
              <p className="text-secondary-500 text-xs leading-relaxed mb-4 line-clamp-4">
                {comment.comment}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-400/50">
                <img
                  src={comment.avatar}
                  alt={comment.user}
                  className="w-8 h-8 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-foreground-800 text-xs font-medium">{comment.user}</p>
                  <p className="text-secondary-600 text-[10px]">{comment.identity}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}